<template>
    <div class="pos">
        <!-- tabs栏 -->
        <div class="tabs">
            <div
                    class="tabs_item"
                    :class="{ activeTabs: activeTabs == index }"
                    @click="changeTabs(index)"
                    v-for="(item, index) in tabsList"
                    :key="index"
            >
                <!-- <div class="badeg">2</div> -->
                <div>{{ item }}</div>
            </div>
            <!-- <div
              v-if="!read"
              class="read"
              :class="{ readMove: readMove }"
              @mouseenter="readMove = true"
              @mouseleave="readMove = false"
            >
              <img
                v-if="readMove"
                src="../../assets/img/personal/icon_5_10.png"
                alt=""
              />
              <img v-else src="../../assets/img/personal/icon_5_5.png" alt="" />
              <div @click="goRead">标记为已读</div>
            </div>
            <div class="read noRead" v-else>
              <img src="../../assets/img/personal/icon_5_5.png" alt="" />
              <div>已标记为已读</div>
            </div>-->
        </div>
        <!-- 答疑列表 -->
        <div class="note_list" v-for="(item, index) in noteList" :key="index">
            <div class="note_item">
                <div class="note_left">
                    <img :src=" headerImg ?imgUrl+ headerImg :'../../assets/img/personal/bg_4_1.png'" alt/>
                </div>
                <div class="note_right">
                    <div class="level">
                        <div>{{userInfo.username}}</div>
                        <div>
                            <span>{{ (item.addtime * 1000) | dateFormat }}</span>
                            <!-- <span>未读</span> -->

                        </div>
                    </div>
                    <div v-if="activeTabs == 0" class="note_desc">{{item.content}}</div>
                    <div v-if="activeTabs == 3" class="note_desc">好好学习</div>
                    <!-- 回复内容 -->
                    <!-- 全部 -->
                    <div class="answer_box" v-if="activeTabs == 0">
                      <div v-for="(item, index) in answerList" :key="index">{{ item }}</div>
                    </div>
                    <div class="from">
                        <div>源自：{{item.answerto}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 分页功能 -->
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-size="length"
                layout="total,  prev, pager, next, jumper"
                :total="total"
        ></el-pagination>
    </div>
</template>
<script>
    import {myAnswering} from "../../assets/js/api.js";
    import store from "store";

    export default {
        data() {
            return {
                imgUrl: ".",
                page: 1,
                limit: 4,
                total: 0,
                noteList: [],
                currentPage4: 1,
                tabsList: ["全部"],
                readMove: false,
                headerImg: "",
                userInfo: "",
                readMove2: -1,
                readMove3: -1,
                read: false,
                activeTabs: 0,
                // tabsList: ["全部", "我提问的", "我回答的", "回复我的"],
                answerList: [],
                answerList2: [],
                show: false,
            };
        },
        mounted() {
            this.userInfo = store.get("info");
            this.headerImg = store.get("header_img");
            this.getData();
        },
        methods: {
            getData() {
                myAnswering(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.page, this.limit).then((res) => {
                    if (res.code == 200) {
                        this.noteList = res.data.records;
                        this.total = res.data.total;
                    }
                });
            },
            changeTabs(i) {
                this.activeTabs = i;
            },
            // 标记为已读
            goRead(i) {
                this.read = true;
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.page = val;
                this.getData();
            },
            // 展开
            showMore() {
                this.answerList = this.answerList2;
                this.show = true;
            },
            // 收起
            closeMore() {
                this.answerList = this.answerList;
                this.show = false;
            },
        },
    };
</script>
<style lang="less" scoped>

    /deep/ .el-pagination {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -50px;
        text-align: center;
    }

    .readMove {
        color: #029aff !important;
    }

    .tabs {
        position: relative;
        width: 100%;
        height: 50px;
        border-bottom: 2px solid #029aff;
        display: flex;
        // align-items: center;
        .read {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 16px;
            color: #343434;
            line-height: 50px;
            cursor: pointer;
            display: flex;
            // align-items: center;
            img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
                margin-top: 15px;
            }
        }
        .noRead {
            color: #666;
            cursor: default;
        }
        .tabs_item {
            position: relative;
            padding: 0 30px;
            box-sizing: border-box;
            height: 100%;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
            font-size: 20px;
            color: #343434;
            .badeg {
                position: absolute;
                top: 5px;
                right: 10px;
                padding: 10px 8px;
                line-height: 1px;
                box-sizing: border-box;
                border-radius: 10px;
                font-size: 12px;
                background-color: #ff0001;
                color: #fff;
            }
        }
    }

    .note_list {
        .note_item {
            display: flex;
            padding-top: 30px;
            padding-bottom: 10px;
            box-sizing: border-box;
            width: 100%;
            border: 1px solid #f2f2f2;
            .note_left {
                margin-right: 10px;
                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
            }
            .note_right {
                width: 100%;
                .level {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 15px 0;
                    div:nth-child(1) {
                        font-size: 18px;
                        color: #343434;
                    }
                    div:nth-child(2) {
                        font-size: 12px;
                        color: #9a9a9a;
                        span:nth-child(2) {
                            color: #029aff;
                            margin-left: 20px;
                        }
                    }
                }
                .note_desc {
                    font-size: 14px;
                    color: #343434;
                    line-height: 1.8;
                }
                .answer_box {
                    width: 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    font-size: 14px;
                    line-height: 1.8;
                    background-color: #f5f5f5;
                    margin-top: 20px;
                    color: #343434;
                    .allAnswer {
                        color: #029aff;
                        cursor: pointer;
                    }
                }
                .from {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 14px;
                    color: #9a9a9a;
                    margin-top: 20px;
                    img {
                        width: 15px;
                        height: 16px;
                        cursor: pointer;
                    }
                }
            }
        }
    }

</style>
